module.exports = __webpack_public_path__ + "static/img/mn.3459f5b3.svg";